import React, { useMemo, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import { ProductProps } from "../../types/productTypes";
import { useLanguageContext } from "../../lib/context/LanguageContext/LanguageContext";
import { useMenuSidebar } from "../../lib/context/MenuSidebarContext/MenuSidebarContext";
import { fields, messages } from "../../lib/translation/strings";
import { useTranslation } from "react-i18next";
import { useWishlist, WishlistAttributes } from "../../lib/hooks/useWishlist";
import { useHistory } from "react-router";
import { Image } from "../../components/shared/Image/Image";
import { LoadingPlaceholder } from "../../components/shared/LoadingPlaceholder/LoadingPlaceholder";
import { Icon } from "../../components/shared/Icon/Icon";
import { ConditionalProductPrice } from "../../components/shared/ConditionalProductPrice/ConditionalProductPrice";

import "./WishlistSidebar.scss";

export const WishlistSidebar = () => {
  const ref = useRef(null);
  const wishlist = useWishlist();
  const menuSidebar = useMenuSidebar();
  const { t } = useTranslation();
  const history = useHistory();
  const lngCtx = useLanguageContext();
  const prefix = lngCtx.getLangPrefix();

  const [state, setState] = useState<WishlistAttributes>({
    loading: true,
    error: undefined,
    data: [],
  });

  const memoizedValue = useMemo(() => menuSidebar.wishtlist, [menuSidebar]);

  // const getWishList = async () => {
  //   setState({
  //     ...state,
  //     loading: true,
  //   });
  //   try {
  //     const res = await wishlist.getUserWishlist();

  //     if (!res) {
  //       return;
  //     }

  //     setState({ ...res, loading: false });

  //   } catch (error) {
  //     setState({
  //       ...state,
  //       loading: false,
  //       error: error as any,
  //     });
  //   }
  // };

  React.useEffect(() => {
    setState({
      ...state,
      loading: true,
    });
    wishlist
      .getUserWishlist()
      .then((res: WishlistAttributes | undefined) => {
        if (res) {
          setState({ ...res, loading: false });
        }
      })
      .catch((e) => {
        setState({
          ...state,
          loading: false,
          error: e,
        });
      });
  }, [memoizedValue]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRemove = async (id: number) => {
    setState({
      ...state,
      loading: true,
    });
    try {
      await wishlist.removeItem(id);

      setState((prev) => {
        return {
          ...prev,
          data: state.data?.filter((item: any) => item.databaseId !== id),
          loading: false,
        };
      });
    } catch (e) {
      setState({
        ...state,
        loading: true,
      });
    }
  };

  return (
    <div
      ref={ref}
      className={cn(
        "WishlistSidebar",
        menuSidebar.wishtlist && "WishlistSidebar--opened"
      )}
    >
      {state.loading && (
        <div className="WishlistSidebar--updating">
          <LoadingPlaceholder />
        </div>
      )}

      <div className="WishlistSidebar-head">
        <p onClick={() => history.push(`${prefix}/my-list`)}>
          {t(fields.myList)}
        </p>
        <span
          role="button"
          onClick={() => menuSidebar.closeSidebar("wishlist")}
        >
          <Icon icon="x" />
        </span>
      </div>
      {state.data.length === 0 ? (
        <div className="WishlistSidebar-empty">{t(messages.emptyList)}</div>
      ) : (
        <>
          <div className="WishlistSidebar-body">
            <ul className="WishlistSidebar-list">
              {state.data?.map((product: ProductProps) => {
                return (
                  <li
                    key={`${product?.id}`}
                    className="WishlistSidebar-list-item"
                  >
                    <NavLink to={`${prefix}/product/${product?.slug}`}>
                      <div className="WishlistSidebar-list-item-image">
                        <Image
                          src={product?.image?.mediaItemUrl}
                          alt={product.name}
                        />
                      </div>
                    </NavLink>
                    <div className="WishlistSidebar-list-item-info">
                      <NavLink to={`${prefix}/product/${product?.slug}`}>
                        <h4>{product?.name}</h4>
                      </NavLink>
                      <ConditionalProductPrice
                        productCategories={product?.productCategories}
                        regular={product.regularPrice}
                        sale={product.salePrice}
                        onSale={product?.onSale}
                      />
                    </div>
                    <button
                      disabled={state.loading}
                      onClick={() => {
                        handleRemove(product.databaseId);
                      }}
                      className="WishlistSidebar-list-item-remove"
                    >
                      <Icon icon="x" />
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};
